(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["saunday-image-navigation"] && !Shopify.designMode) return;
  try {
    if(!window.sdImageNavigationReady){
window.sdImageNavigationReady=true;
document.addEventListener('pointerover',event=>{
const item=event.target.closest('.sd-image-nav');
if(!item||!matchMedia('(hover:hover) and (min-width:1000px)').matches)return;
const details=item.querySelector('details');
document.querySelectorAll('.sd-image-nav details[open]').forEach(other=>{if(other!==details)other.open=false;});
details.style.setProperty('--sd-image-nav-top',Math.max(0,item.closest('x-header').getBoundingClientRect().bottom)+'px');
details.open=true;
});
document.addEventListener('pointerout',event=>{
const item=event.target.closest('.sd-image-nav');
if(!item||item.contains(event.relatedTarget)||!matchMedia('(hover:hover)').matches)return;
setTimeout(()=>{if(!item.matches(':hover')&&!item.contains(document.activeElement))item.querySelector('details').open=false;},220);
});
document.addEventListener('toggle',event=>{
const details=event.target;
if(!details.matches('.sd-image-nav__details')||!details.open)return;
details.style.setProperty('--sd-image-nav-top',Math.max(0,details.closest('x-header').getBoundingClientRect().bottom)+'px');
document.querySelectorAll('.sd-image-nav details[open]').forEach(other=>{if(other!==details)other.open=false;});
},true);
document.addEventListener('click',event=>{
if(!event.target.closest('.sd-image-nav'))document.querySelectorAll('.sd-image-nav details[open]').forEach(details=>{details.open=false;});
});
document.addEventListener('keydown',event=>{
if(event.key==='Escape')document.querySelectorAll('.sd-image-nav details[open]').forEach(details=>{details.open=false;details.querySelector('summary').focus();});
});
document.addEventListener('focusout',event=>{
const item=event.target.closest('.sd-image-nav');
if(item&&!item.contains(event.relatedTarget))item.querySelector('details').open=false;
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saunday-vertical-navigation"] && !Shopify.designMode) return;
  try {
    if(!window.sdGymNavigationReady){
window.sdGymNavigationReady=true;
document.addEventListener('toggle',event=>{
const menu=event.target;
if(!menu.matches('[data-sd-main-menu]')||!menu.open)return;
document.querySelectorAll('[data-sd-main-menu][open]').forEach(other=>{if(other!==menu)other.open=false});
menu.style.setProperty('--sd-main-menu-top',Math.max(0,menu.closest('x-header').getBoundingClientRect().bottom)+'px');
},true);
document.addEventListener('click',event=>{
if(event.target.closest('[data-sd-nav-close]')){const menu=event.target.closest('[data-sd-main-menu]');menu.open=false;menu.querySelector('summary').focus()}
if(!event.target.closest('[data-sd-main-menu]'))document.querySelectorAll('[data-sd-main-menu][open]').forEach(menu=>{menu.open=false});
});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('[data-sd-main-menu][open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus()})});
window.addEventListener('scroll',()=>{if(window.scrollY>180)document.querySelectorAll('[data-sd-main-menu][open]').forEach(menu=>{menu.open=false})},{passive:true});
}
  } catch(e) { console.error(e); }
})();

})();
